import { render, staticRenderFns } from "./EventForm.vue?vue&type=template&id=5a7acd7a"
import script from "./EventForm.vue?vue&type=script&lang=ts"
export * from "./EventForm.vue?vue&type=script&lang=ts"
import style0 from "./EventForm.vue?vue&type=style&index=0&id=5a7acd7a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports